/* eslint-disable jsx-a11y/anchor-is-valid */
import "./styles/RecipientSelector.scss";
import React, { Component } from "react";
import Loading from "./Loading";
import { listRecipientsForNotification } from "../api/recipients";

export default class RecipientViewer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recipients: undefined,
      activeView: "Groups",
    };
  }

  componentDidMount() {
    listRecipientsForNotification(this.props.notificationId).then((res) =>{
       this.setState({ recipients: res })
      });

  }

  render() {
    const renderGroupOrIndividual = (type, data) => {

      return (
        <div className="field" key={data.name}>
          <label>
            {/* {type === "group" ? data.name + " (" + data.Recipients.length + ")" : data.name} */}
            {data.name}
          </label>
        </div>
      );
    };

    const renderGroups = () => {
      if (!this.state.recipients) {
        return (
          <div className="main-rec-container mt-4 mb-4 is-flex is-justify-content-center">
            <Loading />
          </div>
        );
      }

      return (
        <>
          <div className="main-rec-container mt-4 mb-4">
            <div className="field">
              {this.state.recipients.group.map((g) =>
                renderGroupOrIndividual("group", g)
              )}
            </div>
          </div>
        </>
      );
    };

    const renderIndividual = () => {
      if (!this.state.recipients) {
        return (
          <div className="main-rec-container mt-4 mb-4 is-flex is-justify-content-center">
            <Loading />
          </div>
        );
      }

      return (
        <>
          <div className="main-rec-container mt-4 mb-4">
            <div className="field">
              {this.state.recipients.individual.sort((a, b) => a.name.localeCompare(b.name)).map((g) =>
                renderGroupOrIndividual("individual", g)
              )}
            </div>
          </div>
        </>
      );
    };

    return (
      <div className="box recipient-selector">
        <div className="">
          <label className="label mb-4">Recipients</label>

          <div className="tabs">
            <ul>
              <li
                className={
                  this.state.activeView === "Groups" ? "is-active" : ""
                }
              >
                <a onClick={() => this.setState({ activeView: "Groups" })}>
                  Groups
                </a>
              </li>
              <li
                className={
                  this.state.activeView === "Individual" ? "is-active" : ""
                }
              >
                <a onClick={() => this.setState({ activeView: "Individual" })}>
                  Individual
                </a>
              </li>
            </ul>
          </div>

          {this.state.activeView === "Groups" && renderGroups()}
          {this.state.activeView === "Individual" && renderIndividual()}

          <div className="buttons mt-4">
            <button
              className="button is-info is-small"
              onClick={() => this.props.onClose()}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
}
